<template>
    <ai-grid-ro
        ref='gridRef'
        :meta='gridMeta'
        :args='args'
        :to-remove-toolbar-items-names="removeRateToolbarItems"
        :show-grid-footer='false'
        :show-filter-panel='false'
    />
</template>
<script>
export default {
    name: 'tep-av-grid'
};
</script>
<script setup>
import { computed, onMounted, ref } from 'vue';
import AiGridRo from '@/components/ai-grid-ro/ai-grid-ro.vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    },
    serverData: {
        type: Object,
        default: () => {}
    }
});

const gridRef = ref(null);

const args = computed(() => {
    const kod = props.serverData.kod;
    return {
       select_args: {
           kod_sx: kod
       }
    }
})

onMounted(() => {
    gridRef.value?.setDataSource();
})

const removeRateToolbarItems = ['choice', 'settings', 'show-column-chooser', 'searchPanel'];
const gridMeta = {
    keyExpr: 'id_period',
    'api': {
        'select': 'tep-grid./tep/vozk-grid/select/get',
    },
    columns: [
        {
            name: 'id_period',
            caption: 'Id',
            dataField: 'id_period',
            visible: false,
            width: '250',
            index: 1,
            allowFiltering: false
        },
        {
            name: 'kod_aw',
            caption: 'kod_aw',
            dataField: 'kod_aw',
            visible: false,
            width: '250',
            index: 2,
            allowFiltering: false
        },
        {
            name: 'name',
            caption: 'Месяц',
            dataField: 'name',
            visible: true,
            width: '50%',
            index: 3,
            allowFiltering: false
        },
        {
            name: 'pr_voz',
            caption: '% возв. конд.',
            dataField: 'pr_voz',
            visible: true,
            width: '50%',
            index: 4,
            allowFiltering: false,
            'dataType': 'number'
        }
    ],
    viewId: 'view-tep-vozk-grid'
}
</script>

